import theme from '@adsk/alloy-react-theme';

import { TaskStatus } from '../../../../types';

export const TASK_STATUS_COLORS: Record<TaskStatus, string> = {
  [TaskStatus.BACKLOG]: theme.colors.charcoal500,
  [TaskStatus.BLOCKED]: theme.colors.black,
  [TaskStatus.INCOMPLETE]: theme.colors.red500,
  [TaskStatus.COMPLETE]: theme.colors.green300,
  [TaskStatus.IN_PROGRESS]: theme.colors.darkBlue300,
  [TaskStatus.OPEN]: theme.colors.yellowOrange500,
  [TaskStatus.WORK_DONE]: theme.colors.purple300,
};
